export default __webpack_public_path__ + "static/media/13.983e6836.jpg";